import { VStack } from "@chakra-ui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import {
  Navigate,
  Outlet,
  useLocation, useSearchParams
} from "react-router-dom";
import "./App.css";
import ErrorView from "./components/errorView/errorView";
import { LoadingSpinner } from "./components/loadingSpinner/loadingSpinner";
import { useValidateSession } from "./hooks/index";
import { FooterSection } from "./layouts/footerSection";
import { MenuHeader } from "./layouts/menuHeader";
import { createQueryClient } from "./config/reactQueryConfig";

// Istanza QueryClient creata dalla configurazione dedicata
const queryClient = createQueryClient();

function App() {
  let [searchParams] = useSearchParams();
  const location = useLocation();
  const { user, onLoading, onError } = useValidateSession(
    searchParams.get("d")
  );




  return (
    <>
      {onError && (
        <ErrorView error={{ status: "302", msg: "Sessione non valida" }} />
      )}

      {onLoading && <LoadingSpinner isLoading={onLoading} />}
      {user.d.length > 0 && (
        <QueryClientProvider client={queryClient}>
          <VStack p={0}>
            <MenuHeader {...user} />
            <Outlet />
            <FooterSection />
          </VStack>
        </QueryClientProvider>
      )}
    </>
  );
}

export default App;
